import React, { memo } from "react";

const Loader = () => {
  return (
    <div className="loader_cont">
      <div className="loader"></div>;
    </div>
  );
};

export default memo(Loader);
